import { api } from "../../lib/api";
import { useGameStore } from "../../store/gameStore";
import { Input } from "../ui/input";
import { Button } from "../ui/button";
import MonsterBuilderPanel from "./MonsterBuilderPanel";
import { InfoTip } from "./InfoTip";
import { UserPlus, MousePointerClick } from "lucide-react";

export default function GmNpcsTab({ game, scene, tokens, onAddToken, onSpawnToken }) {
  const setSelectedTokenId = useGameStore((s) => s.setSelectedTokenId);
  const npcs = (tokens || []).filter((t) => t.token_type === "npc" && t.scene_id === scene?.id);

  const patchToken = (id, updates) => api.patch(`/games/${game.id}/tokens/${id}`, updates);

  return (
    <div className="space-y-3">
      <p className="text-[10px] uppercase text-[#f1e0c5]/40 flex items-center gap-1.5">NPCs <InfoTip topic="npc_setup" /></p>
      <Button data-testid="gm-add-token-button" onClick={onAddToken} size="sm" className="w-full rounded-full gap-2 bg-[#D90429] hover:bg-[#b8031f]">
        <UserPlus className="w-3.5 h-3.5" /> Add NPC / Enemy Token
      </Button>
      <p className="text-[10px] text-[#f1e0c5]/30">Select a token to edit its dialogue, attack permission, HP and more in the Token Inspector.</p>
      <div className="space-y-1.5">
        {npcs.map((t) => (
          <div key={t.id} data-testid={`gm-npc-row-${t.id}`} className="flex items-center gap-2 bg-black/20 rounded-lg px-2.5 py-2">
            <button data-testid={`gm-npc-select-${t.id}`} onClick={() => setSelectedTokenId(t.id)} className="flex-1 text-left text-sm hover:text-[#D4AF37] flex items-center gap-1.5">
              <MousePointerClick className="w-3 h-3 text-[#f1e0c5]/30" /> {t.name}
            </button>
            <Input
              data-testid={`gm-npc-hp-${t.id}`}
              type="number"
              value={t.hp_current ?? ""}
              placeholder="HP"
              onChange={(e) => patchToken(t.id, { hp_current: parseInt(e.target.value, 10) || 0 })}
              className="w-16 h-7 text-center bg-black/30 border-white/10 text-xs"
            />
          </div>
        ))}
        {npcs.length === 0 && <p className="text-xs text-[#f1e0c5]/30 italic">No NPCs on this scene yet.</p>}
      </div>
      <MonsterBuilderPanel game={game} onSpawnToken={onSpawnToken} />
    </div>
  );
}
